import apiController from './api.js';
import helpers from './helpers.js';
import nls from './nls/index.js';

// TODO add version parameter

const CSS_CHOROPLETH_ONLY = 'choropleth-only';
const CSS_SOCIAL_MEDIA_ONLY = 'social-media-only';

const ATTRIBUTE_ICON_SOCIAL_MEDIA = 'data-icon-social-media';

const ICON_SNAPCHAT = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 5.34857C0 2.39464 2.39464 0 5.34857 0H18.6514C21.6054 0 24 2.39464 24 5.34857V18.6514C24 21.6054 21.6054 24 18.6514 24H5.34857C2.39464 24 0 21.6054 0 18.6514V5.34857Z" fill="#FFFC00"/>
<path d="M12.1109 20.2629C12.0609 20.2629 12.0133 20.261 11.977 20.2593C11.9483 20.2618 11.9186 20.2629 11.8888 20.2629C10.8395 20.2629 10.1379 19.7674 9.51878 19.3299C9.07502 19.0168 8.6565 18.7212 8.16621 18.6397C7.92541 18.5998 7.68587 18.5796 7.45442 18.5796C7.03741 18.5796 6.70784 18.6442 6.46723 18.6912C6.31917 18.72 6.19149 18.7448 6.09282 18.7448C5.98946 18.7448 5.86389 18.7219 5.81156 18.5434C5.77008 18.4026 5.74034 18.2662 5.71162 18.1349C5.63979 17.8066 5.58769 17.6063 5.46465 17.5872C4.1486 17.3844 3.37101 17.0856 3.21612 16.7238C3.19989 16.6858 3.19082 16.6475 3.18881 16.6097C3.18278 16.5018 3.25901 16.4072 3.36545 16.3896C4.41058 16.2177 5.33988 15.6659 6.12766 14.7491C6.73791 14.0393 7.03759 13.3611 7.06977 13.2862C7.07117 13.2829 7.07281 13.2793 7.07449 13.2761C7.22634 12.9684 7.25655 12.7024 7.16456 12.4859C6.99499 12.0865 6.43337 11.9085 6.06181 11.7907C5.9694 11.7615 5.88199 11.7339 5.81236 11.7063C5.48298 11.5763 4.94129 11.3017 5.01345 10.9228C5.06601 10.6464 5.43196 10.454 5.72771 10.454C5.80983 10.454 5.8826 10.4683 5.94387 10.4971C6.27806 10.6535 6.57872 10.7327 6.83729 10.7327C7.15886 10.7327 7.31417 10.6104 7.35172 10.5757C7.34246 10.4043 7.33114 10.2232 7.3202 10.0518C7.3202 10.0517 7.31997 10.0496 7.31997 10.0496C7.24449 8.85025 7.15035 7.35768 7.53257 6.50176C8.67657 3.9397 11.1027 3.74047 11.8188 3.74047C11.8378 3.74047 12.1309 3.73757 12.1309 3.73757C12.1441 3.73734 12.1585 3.73715 12.1733 3.73715C12.8914 3.73715 15.3225 3.93662 16.4672 6.50022C16.8495 7.3567 16.7552 8.85053 16.6795 10.0511L16.676 10.1086C16.6656 10.2716 16.656 10.4259 16.6479 10.5755C16.6833 10.608 16.8254 10.7201 17.1145 10.7315C17.361 10.722 17.6443 10.6431 17.9562 10.4973C18.0527 10.452 18.1594 10.4426 18.2319 10.4426C18.3415 10.4426 18.453 10.4639 18.5459 10.5027L18.5509 10.5046C18.8156 10.5984 18.9889 10.786 18.9927 10.983C18.996 11.1667 18.8593 11.4412 18.1872 11.7064C18.1184 11.7336 18.0305 11.7614 17.9378 11.7908C17.5659 11.9087 17.0047 12.0866 16.8352 12.4858C16.743 12.7023 16.7733 12.9682 16.9252 13.2758C16.9269 13.2792 16.9284 13.2826 16.93 13.2862C16.9768 13.3957 18.1087 15.9738 20.6343 16.3894C20.7407 16.4071 20.8171 16.5018 20.811 16.6095C20.8088 16.6481 20.7994 16.6868 20.783 16.7246C20.6292 17.0844 19.8517 17.3828 18.5353 17.5859C18.4117 17.6049 18.3596 17.8044 18.2885 18.1309C18.259 18.2658 18.229 18.398 18.1881 18.5369C18.1498 18.6676 18.0646 18.7314 17.9278 18.7314H17.9071C17.818 18.7314 17.6918 18.7153 17.5326 18.6842C17.2544 18.6301 16.9423 18.5797 16.5454 18.5797C16.314 18.5797 16.0745 18.6 15.8335 18.6398C15.3437 18.7213 14.9252 19.0164 14.4822 19.3292C13.8619 19.7673 13.1601 20.2629 12.1109 20.2629Z" fill="white"/>
<path d="M12.1732 3.98592C12.8462 3.98592 15.1637 4.16646 16.2558 6.61157C16.6155 7.41671 16.5233 8.8752 16.4493 10.0468C16.4378 10.2328 16.4263 10.413 16.417 10.585L16.4131 10.659L16.4626 10.7141C16.4825 10.7362 16.6695 10.9313 17.0852 10.9474L17.092 10.9477L17.0989 10.9476C17.3738 10.9371 17.6834 10.8519 18.0197 10.6946C18.0692 10.6714 18.1352 10.6601 18.2049 10.6601C18.2844 10.6601 18.3688 10.6751 18.4385 10.7043L18.449 10.7085C18.6253 10.7702 18.75 10.8866 18.7519 10.9918C18.7529 11.0513 18.7083 11.2657 18.0833 11.5123C18.0222 11.5364 17.9418 11.562 17.8486 11.5913C17.4419 11.7203 16.8274 11.9149 16.6206 12.4016C16.5041 12.6757 16.536 12.9992 16.7153 13.363C16.789 13.5349 17.95 16.1464 20.5625 16.5763C20.562 16.5887 20.5588 16.6022 20.5518 16.6181C20.5076 16.7223 20.2261 17.0821 18.4748 17.352C18.2007 17.3939 18.1336 17.7007 18.0557 18.0573C18.0276 18.185 17.999 18.3138 17.9597 18.447C17.9477 18.4872 17.9455 18.4895 17.9023 18.4895C17.8964 18.4895 17.8894 18.4895 17.8817 18.4895C17.8041 18.4895 17.6862 18.4734 17.5495 18.4466C17.3007 18.3982 16.9607 18.3388 16.5261 18.3388C16.2835 18.3388 16.0336 18.3599 15.7829 18.4017C15.247 18.4907 14.8111 18.7985 14.3495 19.1243C13.7296 19.5618 13.0889 20.0144 12.1114 20.0144C12.0687 20.0144 12.027 20.0129 11.9853 20.0109L11.9743 20.0104L11.9632 20.0112C11.9393 20.0133 11.9151 20.0144 11.8904 20.0144C10.913 20.0144 10.272 19.5619 9.65242 19.1243C9.19074 18.7985 8.75467 18.4907 8.21882 18.4017C7.96834 18.36 7.71822 18.3388 7.47579 18.3388C7.04125 18.3388 6.70086 18.4052 6.45251 18.4537C6.31586 18.4804 6.19756 18.5033 6.12013 18.5033C6.05671 18.5033 6.0555 18.4995 6.0421 18.4538C6.0028 18.3206 5.97407 18.1886 5.94609 18.0611C5.86806 17.7042 5.80087 17.3957 5.52697 17.3537C3.77574 17.0836 3.49424 16.7232 3.44983 16.6193C3.44289 16.603 3.43977 16.589 3.43907 16.5767C6.0515 16.1471 7.21226 13.5355 7.28625 13.363C7.46582 12.9995 7.49767 12.676 7.38085 12.4016C7.17404 11.9152 6.55964 11.7203 6.15318 11.5916C6.05974 11.562 5.97929 11.5364 5.91815 11.5123C5.39036 11.304 5.22801 11.0943 5.25213 10.9671C5.28011 10.8205 5.5346 10.6715 5.75669 10.6715C5.8066 10.6715 5.85037 10.6795 5.88272 10.6946C6.24342 10.8635 6.57268 10.949 6.86149 10.949C7.31549 10.949 7.51755 10.7381 7.53925 10.714L7.58846 10.6591L7.5845 10.5855C7.57533 10.4135 7.56402 10.2333 7.5521 10.0478C7.4784 8.87585 7.38621 7.41834 7.74569 6.61315C8.83378 4.17702 11.14 3.98922 11.8208 3.98922C11.8375 3.98922 12.1335 3.9862 12.1335 3.9862C12.1456 3.98611 12.1591 3.98592 12.1732 3.98592ZM12.1732 3.5657H12.1724C12.1569 3.5657 12.1423 3.5657 12.1284 3.56589C12.0178 3.56701 11.8359 3.56877 11.8196 3.56896C11.4208 3.56896 10.6228 3.62522 9.76566 4.00303C9.27557 4.21891 8.83475 4.5108 8.45548 4.87062C8.0033 5.29935 7.63493 5.82795 7.36079 6.44195C6.95931 7.34097 7.05461 8.85526 7.13116 10.0722L7.13144 10.0741C7.13963 10.2044 7.14824 10.3405 7.15611 10.4731C7.09722 10.5001 7.00172 10.5286 6.86097 10.5286C6.63451 10.5286 6.36522 10.4563 6.06077 10.3138C5.97119 10.2722 5.86894 10.2511 5.75613 10.2511C5.57488 10.2511 5.3838 10.3044 5.21805 10.4017C5.00951 10.524 4.87477 10.6968 4.83817 10.8884C4.81405 11.0152 4.81522 11.2657 5.09387 11.5197C5.24715 11.6596 5.47231 11.7886 5.76293 11.9033C5.83919 11.9332 5.9297 11.9619 6.02557 11.9922C6.35823 12.0978 6.86172 12.2574 6.99302 12.5659C7.05955 12.7224 7.03092 12.9283 6.90814 13.1771C6.90493 13.1839 6.90171 13.1906 6.89878 13.1975C6.8681 13.2691 6.58185 13.9166 5.9947 14.5994C5.66106 14.9878 5.29357 15.3123 4.90303 15.5643C4.42636 15.8719 3.91058 16.0731 3.37017 16.162C3.15795 16.1968 3.0064 16.3856 3.01823 16.6001C3.02186 16.662 3.03638 16.7236 3.06157 16.7833C3.06176 16.7837 3.06199 16.784 3.06218 16.7844C3.14799 16.9848 3.34693 17.1551 3.67038 17.3052C4.06562 17.4886 4.65673 17.6428 5.42714 17.7634C5.46607 17.8374 5.50648 18.0232 5.53446 18.1504C5.56375 18.2856 5.59429 18.4246 5.63782 18.5723C5.6848 18.7322 5.80665 18.9234 6.11966 18.9234C6.23829 18.9234 6.37471 18.8967 6.53269 18.8662C6.76404 18.8208 7.08041 18.759 7.47527 18.759C7.6942 18.759 7.92108 18.7782 8.14945 18.8161C8.58967 18.8893 8.96917 19.157 9.40827 19.467C10.051 19.9207 10.7785 20.4343 11.89 20.4343C11.9203 20.4343 11.9507 20.4333 11.9807 20.4312C12.0174 20.4329 12.063 20.4343 12.111 20.4343C13.2228 20.4343 13.9501 19.9206 14.5921 19.4672L14.5932 19.4663C15.0324 19.1567 15.4114 18.8893 15.8515 18.8161C16.0798 18.7783 16.3066 18.759 16.5257 18.759C16.9029 18.759 17.2016 18.807 17.4682 18.8589C17.6423 18.8932 17.7775 18.9096 17.8813 18.9096L17.8915 18.9098H17.902C18.1309 18.9098 18.2991 18.7843 18.3633 18.5647C18.406 18.4202 18.4364 18.2844 18.4665 18.1469C18.4926 18.0277 18.5344 17.8366 18.5734 17.7619C19.3443 17.641 19.9352 17.4871 20.3305 17.3038C20.6532 17.1544 20.8519 16.9843 20.9382 16.7847C20.9641 16.7248 20.9792 16.6628 20.9826 16.5997C20.9948 16.3855 20.843 16.1963 20.6306 16.1615C18.2289 15.7662 17.1469 13.3018 17.1021 13.1971C17.0993 13.1902 17.096 13.1834 17.0926 13.1767C16.9698 12.9278 16.9415 12.7222 17.0081 12.5654C17.1391 12.2571 17.6422 12.0976 17.9751 11.9921C18.0715 11.9617 18.1623 11.9329 18.238 11.9031C18.5657 11.7738 18.8 11.6336 18.9545 11.4743C19.1391 11.2845 19.175 11.1026 19.1728 10.9836C19.1671 10.6956 18.9467 10.4397 18.596 10.3144C18.4775 10.2655 18.3425 10.2397 18.2049 10.2397C18.1113 10.2397 17.9727 10.2525 17.8414 10.3137C17.5604 10.445 17.3087 10.5168 17.0927 10.527C16.9777 10.5212 16.8971 10.4963 16.845 10.4726C16.8515 10.3602 16.8588 10.2448 16.8663 10.1245L16.8694 10.073C16.9464 8.8553 17.042 7.33986 16.6403 6.44019C16.365 5.82399 15.9953 5.29405 15.5414 4.86439C15.1606 4.50434 14.7183 4.21249 14.2264 3.99676C13.3705 3.62173 12.5726 3.5657 12.1732 3.5657Z" fill="#020202"/>
</svg>
`;

const ICON_FACEBOOK = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 5.34857C0 2.39464 2.39464 0 5.34857 0H18.6514C21.6054 0 24 2.39464 24 5.34857V18.6514C24 21.6054 21.6054 24 18.6514 24H5.34857C2.39464 24 0 21.6054 0 18.6514V5.34857Z" fill="#3B5998"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6149 24V14.8046H20.4066L20.8626 10.7177H17.6149V8.7272C17.6149 7.67484 17.6418 6.63089 19.1123 6.63089H20.6018V3.70893C20.6018 3.665 19.3224 3.56575 18.0281 3.56575C15.325 3.56575 13.6324 5.25893 13.6324 8.36801V10.7177H10.6455V14.8046H13.6324V24H17.6149Z" fill="white"/>
</svg>
`;

const ICON_YOUTUBE = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5063 6.61086C23.369 6.1043 23.1015 5.6425 22.7303 5.27138C22.3592 4.90026 21.8974 4.63274 21.3909 4.49543C19.512 4 12 4 12 4C12 4 4.488 4 2.60914 4.49543C1.58057 4.77143 0.771429 5.58229 0.493714 6.61086C0 8.488 0 12.3829 0 12.3829C0 12.3829 0 16.2966 0.493714 18.1549C0.771429 19.1834 1.58229 19.9943 2.60914 20.2703C4.488 20.7657 12 20.7657 12 20.7657C12 20.7657 19.512 20.7657 21.3909 20.2703C21.8974 20.133 22.3592 19.8655 22.7303 19.4943C23.1015 19.1232 23.369 18.6614 23.5063 18.1549C24 16.2777 24 12.3829 24 12.3829C24 12.3829 24 8.488 23.5063 6.61086Z" fill="#FF0000"/>
<path d="M9.58789 16L15.8347 12.4034L9.58789 8.78629V16Z" fill="white"/>
</svg>
`;

const ICON_INSTAGRAM = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.8571 0H5.14286C2.30254 0 0 2.30254 0 5.14286V18.8571C0 21.6975 2.30254 24 5.14286 24H18.8571C21.6975 24 24 21.6975 24 18.8571V5.14286C24 2.30254 21.6975 0 18.8571 0Z" fill="url(#paint0_radial_2538_1222)"/>
<path d="M18.8571 0H5.14286C2.30254 0 0 2.30254 0 5.14286V18.8571C0 21.6975 2.30254 24 5.14286 24H18.8571C21.6975 24 24 21.6975 24 18.8571V5.14286C24 2.30254 21.6975 0 18.8571 0Z" fill="url(#paint1_radial_2538_1222)"/>
<path d="M18.8571 0H5.14286C2.30254 0 0 2.30254 0 5.14286V18.8571C0 21.6975 2.30254 24 5.14286 24H18.8571C21.6975 24 24 21.6975 24 18.8571V5.14286C24 2.30254 21.6975 0 18.8571 0Z" fill="url(#paint2_radial_2538_1222)"/>
<path d="M18.0001 7.28571C18.0001 7.99577 17.4245 8.57143 16.7144 8.57143C16.0044 8.57143 15.4287 7.99577 15.4287 7.28571C15.4287 6.57563 16.0044 6 16.7144 6C17.4245 6 18.0001 6.57563 18.0001 7.28571Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9996 16.2857C14.3665 16.2857 16.2853 14.3669 16.2853 12C16.2853 9.63308 14.3665 7.71428 11.9996 7.71428C9.63267 7.71428 7.71387 9.63308 7.71387 12C7.71387 14.3669 9.63267 16.2857 11.9996 16.2857ZM11.9996 14.5714C13.4198 14.5714 14.571 13.4202 14.571 12C14.571 10.5798 13.4198 9.42856 11.9996 9.42856C10.5794 9.42856 9.42815 10.5798 9.42815 12C9.42815 13.4202 10.5794 14.5714 11.9996 14.5714Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.42871 11.6572C3.42871 8.7769 3.42871 7.33673 3.98925 6.23664C4.48231 5.26894 5.26907 4.48219 6.23676 3.98913C7.33685 3.42859 8.77703 3.42859 11.6573 3.42859H12.343C15.2233 3.42859 16.6634 3.42859 17.7635 3.98913C18.7312 4.48219 19.518 5.26894 20.011 6.23664C20.5716 7.33673 20.5716 8.7769 20.5716 11.6572V12.3429C20.5716 15.2231 20.5716 16.6633 20.011 17.7634C19.518 18.7311 18.7312 19.5178 17.7635 20.0109C16.6634 20.5714 15.2233 20.5714 12.343 20.5714H11.6573C8.77703 20.5714 7.33685 20.5714 6.23676 20.0109C5.26907 19.5178 4.48231 18.7311 3.98925 17.7634C3.42871 16.6633 3.42871 15.2231 3.42871 12.3429V11.6572ZM11.6573 5.14287H12.343C13.8115 5.14287 14.8096 5.14421 15.5812 5.20725C16.3328 5.26865 16.7172 5.37995 16.9853 5.51656C17.6304 5.84528 18.1549 6.36978 18.4836 7.01487C18.6202 7.28299 18.7315 7.66733 18.7929 8.41896C18.8559 9.19056 18.8573 10.1887 18.8573 11.6572V12.3429C18.8573 13.8113 18.8559 14.8095 18.7929 15.5811C18.7315 16.3327 18.6202 16.717 18.4836 16.9852C18.1549 17.6302 17.6304 18.1547 16.9853 18.4834C16.7172 18.6201 16.3328 18.7314 15.5812 18.7928C14.8096 18.8558 13.8115 18.8572 12.343 18.8572H11.6573C10.1888 18.8572 9.19068 18.8558 8.41908 18.7928C7.66745 18.7314 7.28311 18.6201 7.015 18.4834C6.3699 18.1547 5.8454 17.6302 5.51669 16.9852C5.38007 16.717 5.26877 16.3327 5.20737 15.5811C5.14433 14.8095 5.143 13.8113 5.143 12.3429V11.6572C5.143 10.1887 5.14433 9.19056 5.20737 8.41896C5.26877 7.66733 5.38007 7.28299 5.51669 7.01487C5.8454 6.36978 6.3699 5.84528 7.015 5.51656C7.28311 5.37995 7.66745 5.26865 8.41908 5.20725C9.19068 5.14421 10.1888 5.14287 11.6573 5.14287Z" fill="white"/>
<defs>
<radialGradient id="paint0_radial_2538_1222" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.57143 18) rotate(-55.3758) scale(21.8739)">
<stop stop-color="#B13589"/>
<stop offset="0.79309" stop-color="#C62F94"/>
<stop offset="1" stop-color="#8A3AC8"/>
</radialGradient>
<radialGradient id="paint1_radial_2538_1222" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.71429 24.8571) rotate(-65.1363) scale(19.3665)">
<stop stop-color="#E0E8B7"/>
<stop offset="0.444662" stop-color="#FB8A2E"/>
<stop offset="0.71474" stop-color="#E2425C"/>
<stop offset="1" stop-color="#E2425C" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint2_radial_2538_1222" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-1.28571 0.857143) rotate(-8.1301) scale(33.3351 7.13002)">
<stop offset="0.156701" stop-color="#406ADC"/>
<stop offset="0.467799" stop-color="#6A45BE"/>
<stop offset="1" stop-color="#6A45BE" stop-opacity="0"/>
</radialGradient>
</defs>
</svg>
`;

const MAP_TYPES = {
    HEAT: 'heat',
    CHOROPLETH: 'choropleth',
    TRENDS: 'trends',
    SOCIAL_MEDIA: 'socialMedia'
};

const FORM_ELEMENTS_NAMES = {
    ISP: 'ispID',
    ACCESS_TYPE: 'accessTypeID',
    ACCESS_TYPE_CELLULAR: 'accessTypeCellularID',
    ACCESS_TYPE_WIFI: 'accessTypeWifiID',
    TECHNOLOGY_TYPE: 'technologyID',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
    SOCIAL_MEDIA: 'socialMedia'
};

const FORM_ROWS_ID = {
    ISP: 'isp',
    ACCESS_TYPE: 'accessType',
    ACCESS_TYPE_CELLULAR: 'accessTypeCellular',
    ACCESS_TYPE_WIFI: 'accessTypeWifi',
    TECHNOLOGY_TYPE: 'technology',
    DATE_RANGE: 'dateRange',
    SOCIAL_MEDIA: 'socialMedia'
}

const ISP_CODES = {
    BATELCO: 42601,
    ZAIN: 42602,
    STC: 42604
}

export default class TRAUIMap {

    constructor() {
        this.apiController = apiController;
        this.helpers = helpers;
        this.nls = nls;

        this.properties = {
            options: null,
            type: null,
            formRendered: false,
            queryParams: null,
            locationFromUrl: {
                lat: null,
                lng: null
            },
            ispFromUrl: null,
            averageSpeed: null,
            debug: false,
            zoom: null,
            startDateFromUrl: null, // custom startDate parameter from url in debug mode
            endDateFromUrl: null, // custom endDate parameter from url in debug mode

            previousProperties: {
                [MAP_TYPES.HEAT]: null,
                [MAP_TYPES.CHOROPLETH]: null,
                [MAP_TYPES.TRENDS]: null,
                [MAP_TYPES.SOCIAL_MEDIA]: null
            },
            choroplethFirstLoad: true,

            accessTypeList: [],
            technologyTypeList: [],
            ispTypeList: [],
            suggestionsGeojson: [],
            suggestionsFullList: [],
            isFormOpened: false
        };

        this.elements = {
            form: null,
            btnInternetSpeeds: null,
            btnNetworkCoverage: null,
            btnSocialMedia: null,
            btnFilter: null,
            btnFullScreen: null,
            iframe: null,
            btnToggleForm: null
        };
    }

    init(options) {
        this.properties.options = options;

        document.body.classList.add(options.type);

        this.setDebug();
        this.setPeriod();
        this.setLanguage();
        this.setLocation();
        this.setZoom();
        this.setISP();
        this.setAverageSpeedInfo();

        this.renderIframe();
        this.getElements();
        this.initEvents();
        this.translate();
        this.toggleForm();
    }

    setDebug() {
        const debug = new URLSearchParams(window.location.search).get('debug');
        this.properties.debug = !!debug;
    }

    setPeriod() {
        if (this.properties.debug) {
            const startDate = new URLSearchParams(window.location.search).get('startDate');
            if (startDate) {
                this.properties.startDateFromUrl = startDate;
            }

            const endDate = new URLSearchParams(window.location.search).get('endDate');
            if (endDate) {
                this.properties.endDateFromUrl = endDate;
            }

            if (startDate == 'lastmonth' && endDate == 'lastmonth') {
                const allMonth = this.helpers.getMonthPickerData(this.nls.getTranslationByAttr('inputs.monthPicker.months', this.properties.lang));
                const lastMonth = allMonth[0];
                this.properties.startDateFromUrl = lastMonth.startDate;
                this.properties.endDateFromUrl = lastMonth.endDate;
            }
        }
    }

    setLanguage() {
        // console.log('setLanguage');
        const lang = new URLSearchParams(window.location.search).get('lang');
        this.properties.lang = lang != undefined ? lang : 'en';
    }

    setLocation() {
        const lat = new URLSearchParams(window.location.search).get('lat');
        const lng = new URLSearchParams(window.location.search).get('lng');

        if (lat != undefined && lng != undefined) {
            this.properties.locationFromUrl.lat = lat;
            this.properties.locationFromUrl.lng = lng;
        }
    }

    setZoom() {
        const zoom = new URLSearchParams(window.location.search).get('zoom');
        this.properties.zoom = zoom != undefined ? zoom : null;
    }

    setISP() {
        const ispCode = new URLSearchParams(window.location.search).get('isp');
        if (ispCode != undefined) {
            let isp = null;
            for (let prop in ISP_CODES) {
                if (ISP_CODES[prop] == ispCode) {
                    isp = prop.toLowerCase();
                }
            }

            if (isp != null) {
                this.properties.ispFromUrl = isp;
            }
        }
    }

    setAverageSpeedInfo() {
        const averageSpeed = new URLSearchParams(window.location.search).get('averageSpeed');
        this.properties.averageSpeed = averageSpeed != undefined ? averageSpeed : null;
    }

    renderIframe() {
        let iframe = document.createElement('iframe');
        let iframeUrl = this.properties.options.iframeUrl;
        iframe.setAttribute('src', iframeUrl);
        iframe.setAttribute('id', 'scTraIframe');


        let body = document.querySelector('body');
        this.elements.iframe = iframe;
        body.appendChild(iframe);
    }

    getElements() {
        this.elements.mapContainer = document.getElementById('mapContainer');
        // this.elements.title = document.getElementById('title');
        this.elements.form = document.getElementById('formFilters');
        this.elements.formWrapper = document.getElementById('formFiltersWrapper');
        this.elements.iframe = document.getElementById('scTraIframe');
        this.elements.btnNetworkCoverage = document.getElementById('btnNetworkCoverage');
        this.elements.btnSocialMedia = document.getElementById('btnSocialMedia');
        this.elements.btnInternetSpeeds = document.getElementById('btnInternetSpeeds');
        this.elements.btnFilter = document.querySelectorAll('.btn-filter');
        this.elements.btnFullScreen = document.querySelector('#btnFullScreen');
        this.elements.btnToggleForm = document.querySelector('#btnToggleForm');
    }

    initEvents() {
        this.elements.btnNetworkCoverage.addEventListener('click', (e) => {
            e.preventDefault();

            document.body.classList.add(MAP_TYPES.HEAT);
            document.body.classList.remove(MAP_TYPES.CHOROPLETH);
            document.body.classList.remove(MAP_TYPES.SOCIAL_MEDIA);

            const options = {
                type: MAP_TYPES.HEAT
            };
            this.saveSelectedProperties(MAP_TYPES.HEAT);
            this.createMap(options);
        });

        this.elements.btnInternetSpeeds.addEventListener('click', (e) => {
            e.preventDefault();

            document.body.classList.add(MAP_TYPES.CHOROPLETH);
            document.body.classList.remove(MAP_TYPES.HEAT);
            document.body.classList.remove(MAP_TYPES.SOCIAL_MEDIA);

            const options = {
                type: MAP_TYPES.CHOROPLETH
            };

            this.saveSelectedProperties(MAP_TYPES.CHOROPLETH);
            this.createMap(options);
            this.properties.choroplethFirstLoad = false;
        });

        if (this.elements.btnSocialMedia) {
            this.elements.btnSocialMedia.addEventListener('click', (e) => {
                e.preventDefault();

                document.body.classList.add(MAP_TYPES.SOCIAL_MEDIA);
                document.body.classList.remove(MAP_TYPES.HEAT);
                document.body.classList.remove(MAP_TYPES.CHOROPLETH);


                const options = {
                    type: MAP_TYPES.SOCIAL_MEDIA
                };

                this.saveSelectedProperties(MAP_TYPES.SOCIAL_MEDIA);
                this.createMap(options);
                this.properties.choroplethFirstLoad = false;
            });
        }

        this.elements.btnFullScreen.addEventListener('click', (e) => {
            this.handleBtnFullScreenClick();
        });

        document.querySelector('body').addEventListener('fullscreenchange', (e) => {
            this.updateBtnFullScreen();
        });

        // on form change
        this.elements.form.addEventListener('change', (e) => {
            e.preventDefault();
            this.updateForm();
            this.updateMap();
        });

        window.addEventListener('resize', () => {
            this.setMapHeight();
        });

        window.addEventListener('sc_tra_iframeCreated', (e) => {
            this.saveSelectedProperties();
            this.createMap(this.properties.options);
        });


        for (let index = 0; index < this.elements.btnFilter.length; index++) {
            const element = this.elements.btnFilter[index];
            element.addEventListener('click', (e) => {
                e.preventDefault();

                for (let index = 0; index < this.elements.btnFilter.length; index++) {
                    const element = this.elements.btnFilter[index];
                    element.classList.remove('active');
                }
                element.classList.add('active');
            });
        }

        this.elements.btnToggleForm.addEventListener('click', () => {
            this.properties.isFormOpened = !this.properties.isFormOpened;

            this.toggleForm();
            this.setMapHeight();
        });
    }

    toggleForm() {
        const attrShow = 'toggleFormBtn.show';
        const attrHide = 'toggleFormBtn.hide';

        window.dispatchEvent(new Event('resize'));

        if (this.properties.isFormOpened) {
            this.elements.form.classList.remove('collapsed');
            this.elements.btnToggleForm.classList.remove('collapsed');
            this.elements.btnToggleForm.innerHTML = this.nls.getTranslationByAttr(attrHide, this.properties.lang);
        } else {
            this.elements.form.classList.add('collapsed');
            this.elements.btnToggleForm.classList.add('collapsed');
            this.elements.btnToggleForm.innerHTML = this.nls.getTranslationByAttr(attrShow, this.properties.lang);
        }
    }

    translate() {
        this.nls.translate(this.properties.lang);
    }

    handleBtnFullScreenClick() {
        const body = document.querySelector('body');

        // exit from fullscreen
        if (document.fullscreenElement) {
            this.disableFullScreen();
        }
        // enter to fullscreen
        else {
            this.enableFullScreen({
                element: body
            });
        }
    }

    enableFullScreen(options) {
        const element = options.element;

        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) { /* Safari */
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { /* IE11 */
            element.msRequestFullscreen();
        }
    }

    disableFullScreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen()
        }
    }

    updateBtnFullScreen() {
        const cssClass = 'active';
        const attrValueMaxView = 'fullScreenBtn.enter';
        const attrValueMinView = 'fullScreenBtn.exit';

        if (document.fullscreenElement) {
            this.elements.btnFullScreen.innerHTML = this.nls.getTranslationByAttr(attrValueMinView, this.properties.lang);
            this.elements.btnFullScreen.classList.add(cssClass);
        } else {
            this.elements.btnFullScreen.innerHTML = this.nls.getTranslationByAttr(attrValueMaxView, this.properties.lang);
            this.elements.btnFullScreen.classList.remove(cssClass);
        }
    }

    /**
     * Show/hide elements on the form if form was changed
     */
    updateForm() {
        // hide technology filter if wifi selected
        let queryParamsUI = this.helpers.getQueryParamsFromUI(this.elements.form);
        let technologyTypeElement = document.getElementById(FORM_ROWS_ID.TECHNOLOGY_TYPE);
        let accessType = document.getElementById(FORM_ROWS_ID.ACCESS_TYPE);
        let accessTypeWifi = document.getElementById(FORM_ROWS_ID.ACCESS_TYPE_WIFI);
        let accessTypeCellular = document.getElementById(FORM_ROWS_ID.ACCESS_TYPE_CELLULAR);

        if (!technologyTypeElement || !accessTypeWifi || !accessTypeCellular) {
            return;
        }

        if (this.properties.type === MAP_TYPES.HEAT) {
            technologyTypeElement.classList.remove('visibility-hidden');
            technologyTypeElement.classList.remove('hidden');
            accessType.classList.add('hidden');
            accessTypeWifi.classList.add('hidden');
            accessTypeCellular.classList.add('hidden');
        }

        else if (
            this.properties.type === MAP_TYPES.CHOROPLETH ||
            this.properties.type === MAP_TYPES.SOCIAL_MEDIA
        ) {
            accessType.classList.remove('hidden');
            technologyTypeElement.classList.add('hidden');

            // wifi access type
            if (queryParamsUI.accessTypeID == 1) {
                accessTypeWifi.classList.remove('hidden');
                accessTypeCellular.classList.add('hidden');
            }

            // cellular access type
            else if (queryParamsUI.accessTypeID == 2) {
                accessTypeCellular.classList.remove('hidden');
                accessTypeWifi.classList.add('hidden');
            }
        }

        // TODO improve
        // hide 'All' options in Access type if map type is not choropleth
        let choroplethElementsOnly = this.getChoroplethElementsOnly();
        if (choroplethElementsOnly != undefined && choroplethElementsOnly.length) {
            if (this.properties.type === MAP_TYPES.CHOROPLETH || this.properties.type === MAP_TYPES.SOCIAL_MEDIA) {
                for (let index = 0; index < choroplethElementsOnly.length; index++) {
                    const element = choroplethElementsOnly[index];
                    element.classList.remove('hidden');
                }
            } else {
                for (let index = 0; index < choroplethElementsOnly.length; index++) {
                    const element = choroplethElementsOnly[index];
                    element.classList.add('hidden');
                }
            }

        }
    }

    getChoroplethElementsOnly() {
        return document.querySelectorAll(
            `#${FORM_ROWS_ID.ACCESS_TYPE} label:nth-last-of-type(1)
            `
        );
    }

    getIspAll() {
        return document.querySelector(
            `.row-filter-isp .custom-select .select-items div:nth-last-of-type(1)`
        );
    }

    renderTitle() {
        let attrValue = '';
        switch (this.properties.type) {
            case MAP_TYPES.HEAT:
                attrValue = 'titles.networkCoverage'
                break;

            case MAP_TYPES.CHOROPLETH:
                attrValue = 'titles.internetSpeeds'
                break;

            case MAP_TYPES.TRENDS:
                attrValue = 'titles.usageTrends'
                break;

            case MAP_TYPES.SOCIAL_MEDIA:
                attrValue = 'titles.socialMedia'
                break;

            default:
                break;
        }
        this.elements.title.innerHTML = this.nls.getTranslationByAttr(attrValue, this.properties.lang);
    }

    createMap(options) {
        // // prevent double creation the same map
        if (this.properties.type === options.type) {
            return;
        }
        this.properties.type = options.type;

        this.reset();
        // this.renderTitle();

        this.renderForm().then(() => {
            this.translate();
            this.updateForm();
            this.setMapHeight();

            this.loadPreviousProperties();

            this.properties.queryParams = this.helpers.getQueryParamsFromUI(this.elements.form, this.getElementsToHideInQueryParams());

            // TODO improve ?
            // always hardcode access type
            if (this.properties.type === MAP_TYPES.HEAT) {
                this.properties.queryParams[FORM_ELEMENTS_NAMES.ACCESS_TYPE] = 2;
            }


            const event = new CustomEvent('sc_tra_createMap', {
                detail: {
                    type: this.properties.type,
                    lang: this.properties.lang,
                    locationFromUrl: this.properties.locationFromUrl,
                    zoom: this.properties.zoom,
                    startDateFromUrl: this.properties.startDateFromUrl,
                    endDateFromUrl: this.properties.endDateFromUrl,
                    queryParams: this.properties.queryParams,
                    averageSpeed: this.properties.averageSpeed,
                    debug: this.properties.debug,
                    accessTypeList: this.properties.accessTypeList,
                    technologyTypeList: this.properties.technologyTypeList,
                    ispTypeList: this.properties.ispTypeList
                }
            });
            this.elements.iframe.contentWindow.dispatchEvent(event);
        });
    }

    updateMap() {

        this.properties.queryParams = this.helpers.getQueryParamsFromUI(this.elements.form, this.getElementsToHideInQueryParams());

        // TODO improve ?
        // always hardcode access type
        if (this.properties.type === MAP_TYPES.HEAT) {
            this.properties.queryParams[FORM_ELEMENTS_NAMES.ACCESS_TYPE] = 2;
        }
        this.properties.loading = true;

        const event = new CustomEvent('sc_tra_updateMap', {
            detail: {
                queryParams: this.properties.queryParams,
                showInfoForPlace: this.properties.showInfoForPlace,
                debug: this.properties.debug
            }
        });
        this.elements.iframe.contentWindow.dispatchEvent(event);
    }

    reset() {
        this.properties.queryParams = null;
    }

    renderForm() {
        return new Promise((resolve, reject) => {
            if (this.properties.formRendered) {
                resolve();
            } else {
                this.elements.form.innerHTML = '';

                this.renderMonthPicker();
                this.renderSocialMediaPicker();

                Promise.all([
                    this.renderFilterAccess(),
                    this.renderFilterTechnology(),
                    this.renderFilterISP()
                ]).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            }
        });
    }

    /** Set map height after form was rendered. height = bodyHeight - formHeight. Page should be without scroll */
    setMapHeight() {
        const height = this.helpers.calculateMapHeight(this.elements.iframe);
        this.elements.iframe.setAttribute('style', `height: ${height}px`);
    }

    getElementsToHideInQueryParams() {
        // set technology type filter to "" for all maps except heatmap
        let elementsToSkip = [];
        if (this.properties.type !== MAP_TYPES.HEAT) {
            elementsToSkip.push(FORM_ELEMENTS_NAMES.TECHNOLOGY_TYPE);
        }

        // skip social media filter for all maps except social media experience map
        if (this.properties.type !== MAP_TYPES.SOCIAL_MEDIA) {
            elementsToSkip.push(FORM_ELEMENTS_NAMES.SOCIAL_MEDIA);
        }

        return elementsToSkip;
    }

    renderFilterAccess() {
        return new Promise((resolve, reject) => {
            apiController.getAccessTypeList()
                .then((data) => {
                    data = data.map(e => {
                        if (e.Value == 'wifi') {
                            e.css = 'wifi';
                        } else if (e.Value == 'cellular') {
                            e.css = 'cellular';
                        } else if (e.Value == 'both') {
                            e.css = 'both';
                            return;
                        }
                        return e;
                    }).filter(e => e);
                    this.properties.accessTypeList = data;

                    this.renderHtml(data, {
                        type: 'radio',
                        name: FORM_ELEMENTS_NAMES.ACCESS_TYPE,
                        css: 'order-1 row-filter-access-type',
                        id: FORM_ROWS_ID.ACCESS_TYPE,
                        indexToSelect: 1,
                        titleCss: 'filter-title',
                        hideText: true,
                        nlsAttributeValues: {
                            // title of the label
                            title: 'inputs.accessType.title',

                            /*
                             * HARDCODED
                             *
                             * Translations for radioelements. 1 - is ID of wifi value from api. 2 - is ID of cellular value from api
                             */
                            elements: {
                                1: '',
                                2: ''
                            }
                        }
                    });

                    // render all users/5G users
                    const dataCellular = [{
                        ID: 1,
                        Value: 'All Users',
                        css: 'access-item access-item-left'
                    }, {
                        ID: 2,
                        Value: '5G Users',
                        css: 'access-item access-item-right'
                    }];
                    this.renderHtml(dataCellular, {
                        type: 'radio',
                        name: FORM_ELEMENTS_NAMES.ACCESS_TYPE_CELLULAR,
                        css: 'order-2 row-filter-access-type',
                        id: FORM_ROWS_ID.ACCESS_TYPE_CELLULAR,
                        indexToSelect: 0,
                        titleCss: 'filter-title',
                        // TODO
                        nlsAttributeValues: {

                            /*
                             * TODO HARDCODED
                             *
                             * Translations for radioelements. 1 - is ID of wifi value from api. 2 - is ID of cellular value from api
                             */
                            elements: {
                                1: '',
                                2: ''
                            }
                        }
                    });

                    // render wifi options
                    const dataWifi = [{
                        ID: 1,
                        Value: 'Fixed',
                        css: 'access-item access-item-left'
                    }, {
                        ID: 2,
                        Value: 'Fixed Wireless',
                        css: 'access-item access-item-right'
                    }];
                    this.renderHtml(dataWifi, {
                        type: 'radio',
                        name: FORM_ELEMENTS_NAMES.ACCESS_TYPE_WIFI,
                        css: 'order-2 row-filter-access-type',
                        id: FORM_ROWS_ID.ACCESS_TYPE_WIFI,
                        indexToSelect: 0,
                        titleCss: 'filter-title',
                        // TODO
                        nlsAttributeValues: {

                            /*
                             * TODO HARDCODED
                             *
                             * Translations for radioelements. 1 - is ID of wifi value from api. 2 - is ID of cellular value from api
                             */
                            elements: {
                                1: '',
                                2: ''
                            }
                        }
                    });

                    resolve();
                }).catch((error) => {
                    console.error('Request to API.ACCESS_TYPE_LIST failed.', error);
                });
        });
    }

    renderFilterTechnology() {
        return new Promise((resolve, reject) => {
            apiController.getWifiValueTypeList()
                .then((data) => {

                    // leave only 4G and 5G
                    data = data.filter(e => e.Value == '4g' || e.Value == '5g').map(e => {
                        e.css = 'small';
                        return e;
                    });

                    this.properties.technologyTypeList = data;
                    let additionalHtml = null;
                    // let options5G = {
                    // 	type: 'checkbox',
                    // 	name: 'custom5G',
                    // 	css: 'order-3',
                    // 	id: 'custom5G'
                    // };
                    // additionalHtml = this.helpers.getHtmlRadioMock([{ Value: '5G', ID: '' }], options5G);

                    if (this.properties.debug) {
                        additionalHtml = null;
                    }

                    let options = {
                        type: 'radio',
                        name: FORM_ELEMENTS_NAMES.TECHNOLOGY_TYPE,
                        css: 'order-2',
                        additionalFields: [{
                            ID: '',
                            Value: 'All',
                            css: 'small'
                        }],
                        additionalHtml: additionalHtml,
                        titleCss: 'filter-title',
                        id: FORM_ROWS_ID.TECHNOLOGY_TYPE,
                        nlsAttributeValues: {
                            // title of the label
                            title: 'inputs.technology.title',

                            /*
                             * HARDCODED
                             *
                             * Translations for radioelements. 2 - is ID of 2g value from api. 3 - 3g, 4g, 5 - 5g
                             */
                            elements: {
                                2: 'inputs.technology.2g',
                                3: 'inputs.technology.3g',
                                4: 'inputs.technology.4g',
                                5: 'inputs.technology.5g'
                            }
                        }
                    }

                    if (this.properties.options.hidden5g) {
                        options.hiddenValue = '5g';
                    }

                    this.renderHtml(data, options);



                    // on click 5g
                    // TODO improve logic
                    // let label5Gmock = document.querySelector('[label-mock]');
                    // if (label5Gmock) {
                    // 	label5Gmock.addEventListener('click', (e) => {
                    // 		// alert('5G coverage maps are not yet available.');
                    // 		let modal = document.getElementById("traModal");
                    // 		modal.style.display = "block";
                    // 		let content = document.querySelector('#traModal .content');
                    // 		content.innerHTML = '5G coverage maps are not yet available.';
                    // 	});
                    // }

                    resolve();

                }).catch((error) => {
                    console.error('Request to API.TECHNOLOGY_TYPE_LIST failed.', error);
                });
        });
    }

    renderFilterISP() {
        return new Promise((resolve, reject) => {
            apiController.getISPList()
                .then((data) => {
                    this.properties.ispTypeList = data;

                    this.renderHtml(data, {
                        type: 'select',
                        name: FORM_ELEMENTS_NAMES.ISP,
                        css: 'order-3 row-filter-isp',
                        id: FORM_ROWS_ID.ISP,
                        titleCss: 'filter-title',
                        nlsAttributeValues: {
                            // title of the label
                            title: 'inputs.isp.title',
                        }
                    });


                    resolve();

                }).catch((error) => {
                    console.error('Request to API.ISP_LIST failed.', error);
                });
        });
    }

    renderMonthPicker() {

        const data = this.helpers.getMonthPickerData(this.nls.getTranslationByAttr('inputs.monthPicker.months', this.properties.lang));
        this.renderHtml(data, {
            type: 'monthPicker',
            nameStartDate: FORM_ELEMENTS_NAMES.START_DATE,
            nameEndDate: FORM_ELEMENTS_NAMES.END_DATE,
            css: 'order-4 row-filter-month-picker',
            titleCss: 'filter-title',
            width: 150,
            id: FORM_ROWS_ID.DATE_RANGE,
            nlsAttributeValues: {
                // title of the label
                title: 'inputs.monthPicker.title'
            }
        });
    }

    renderSocialMediaPicker() {

        let imgSnapchat = document.createElement('img');
        imgSnapchat.setAttribute('src', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALESURBVHgB7ZpPaBNBFMa/N8YK2kLBKqQXIyhiTwnRS8G0OXoQW3oRD4I9iKWgePUiuXgtRUS8BQ+i7aVe1FsjgSjSYqQHKT00nhr8RyCx0CbZ58y2SdPubkww2c1IfpdMZmfgfbNv3tvZtwQHhq8/DgqIMWYaAXEQTP1wE+IcDEqDKF1mY/bDi6mM7bCDHaPXngS2Bc0QYwwdBBPihsGxg0L2CVCrThCLrq92gzCQQak8npqfTlf6qgI63fg9OMclI1oRYQpQblMkWpTNALSAc2VGSLmTUH+Lgh5AG+MV1C+IZszW7uqvQ0O4VA75iiTumtvDI0JDg4iEAwjK395jPdX+wu9tFDa35O8WZp+9R/ZH3jr5kO+qTxofhAecPXUcd24MI3R+0H7AwF5z7s2KrQACj/p2kxTcJBI+jftTI+g9egT/hLRduB02/Sf6WmO8idzMcJnJiXCLjN/BVQFq9S9HzqGV+OAijhu2htfvVpFczphRqMLa11+O410VcEZGnnoo4x8+TaAZXHeheiSXm8+nrgqoTVR21LpNo7gehVpNV4DXaC+gLWF0cuKCjDi9ln7/QN9f59k9tK1lfmLu7YrtnLYICA35G0pa1nlOc1Yd52jhQhvf847XugLcIKu7gMKmc4bWxIUKjtc6XoA61KvDvRNtCaPJpQyy36x+e+lioO5pLLm0bnmgy9cxXtEWAeotgh2PTl6pmx/UvE9fNtAM3Wchr+kK8JquAK/5DwSoaqC2cE693E1DV6TtgokS0BVZQxYo0itoiiqAi9T8rbQsMC1AM5gRr1Ype5jv6bSZVcHbAMdU2xSQkEoYRlQLEcpGKo9XPjmo5oHU8+m0KUKV8zsVabyyUdla6dqXyNSFw8xReY/i6DDUPi0bCNUar7AcaBI7t+amLIDHiixryEJWMT383IZBiRLzwseXtz/bDfsDYHoTywr1gNMAAAAASUVORK5CYII=')
        const data = [
            {
                index: 0,
                ID: 0,
                Value: 'YouTube',
                selected: true,
                // appendHTML: ICON_YOUTUBE,
                appendHTMLAttribute: `${ATTRIBUTE_ICON_SOCIAL_MEDIA}="youtube"`
            },
            {
                index: 1,
                ID: 1,
                Value: 'Facebook',
                selected: false,
                // appendHTML: ICON_FACEBOOK,
                appendHTMLAttribute: `${ATTRIBUTE_ICON_SOCIAL_MEDIA}="facebook"`
            },
            {
                index: 2,
                ID: 2,
                Value: 'Instagram',
                selected: false,
                appendHTMLAttribute: `${ATTRIBUTE_ICON_SOCIAL_MEDIA}="instagram"`
            },
            {
                index: 3,
                ID: 3,
                Value: 'Snapchat',
                selected: false,
                // appendHTML: imgSnapchat,
                appendHTMLAttribute: `${ATTRIBUTE_ICON_SOCIAL_MEDIA}="snapchat"`
            }
        ];

        this.renderHtml(data, {
            type: 'select',
            name: FORM_ELEMENTS_NAMES.SOCIAL_MEDIA,
            css: `order-1 ${CSS_SOCIAL_MEDIA_ONLY}`,
            id: FORM_ROWS_ID.SOCIAL_MEDIA,
            titleCss: 'filter-title',
            nlsAttributeValues: {
                // title of the label
                title: 'inputs.socialMedia.title',
            }
        });
    }

    // render html from response
    renderHtml(data, options) {
        switch (options.type) {
            case 'radio':
                this.renderHtmlRadio(data, options);
                break;

            case 'select':
                this.renderHtmlSelect(data, options);
                break;

            case 'monthPicker':
                this.renderHtmlMonthPicker(data, options);
                break;

            default:
                break;
        }
    }

    renderHtmlRadio(data, options) {
        let div = document.createElement('div');
        div.innerHTML = this.helpers.getHtmlRadio(data, options);

        if (options.additionalHtml) {
            div.innerHTML += options.additionalHtml;
        }
        div.setAttribute('class', `row-filter ${options.css}`);
        div.setAttribute('id', options.id);

        this.elements.form.appendChild(div);
    }

    renderHtmlSelect(data, options) {
        this.renderHtmlSelectNative(data, options);
        this.renderHtmlSelectCustom();
    }

    renderHtmlSelectNative(data, options) {
        let div = document.createElement('div');
        div.setAttribute('class', `row-filter ${options.css}`);
        div.innerHTML = this.helpers.getHtmlStringSelectNative(data, options);
        this.elements.form.appendChild(div);
    }

    //taken and customized https://www.w3schools.com/howto/howto_custom_select.asp
    renderHtmlSelectCustom() {
        var self = this;
        var x, i, j, selElmnt, a, b, c;
        /* Look for any elements with the class "custom-select": */
        x = document.getElementsByClassName("custom-select");
        for (i = 0; i < x.length; i++) {
            if (x[i].classList.contains('rendered')) {
                continue;
            }


            selElmnt = x[i].getElementsByTagName("select")[0];
            /* For each element, create a new DIV that will act as the selected item: */
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            const dataIconSocialMedia = selElmnt.options[selElmnt.selectedIndex].getAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA);
            if (dataIconSocialMedia) {
                a.setAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA, dataIconSocialMedia);
            }
            x[i].appendChild(a);
            /* For each element, create a new DIV that will contain the option list: */
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 0; j < selElmnt.length; j++) {
                /* For each option in the original select element,
                create a new DIV that will act as an option item: */
                c = document.createElement("DIV");
                c.innerHTML = selElmnt.options[j].innerHTML;
                const dataIconSocialMedia = selElmnt.options[j].getAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA);
                if (dataIconSocialMedia) {
                    c.setAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA, dataIconSocialMedia);
                }

                // c.setAttribute('class', selElmnt.options[j].getAttribute('class'));
                c.addEventListener("click", function (e) {
                    /* When an item is clicked, update the original select box,
                    and the selected item: */
                    var y, i, k, s, h;
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < s.length; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {
                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName("same-as-selected");
                            for (k = 0; k < y.length; k++) {
                                y[k].removeAttribute("class");
                            }
                            this.setAttribute("class", "same-as-selected");

                            const dataIconSocialMedia = this.getAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA);
                            if (dataIconSocialMedia) {
                                h.setAttribute(ATTRIBUTE_ICON_SOCIAL_MEDIA, dataIconSocialMedia);
                            }
                            break;
                        }
                    }
                    h.click();

                    // fire event form change
                    const event = new Event('change');
                    self.elements.form.dispatchEvent(event);
                });
                b.appendChild(c);
            }
            x[i].appendChild(b);
            x[i].classList.add('rendered');

            a.addEventListener("click", function (e) {
                /* When the select box is clicked, close any other select boxes,
                and open/close the current select box: */
                e.stopPropagation();
                self.closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
            });
        }


        /* If the user clicks anywhere outside the select box,
        then close all select boxes: */
        document.addEventListener("click", self.closeAllSelect);
    }

    renderHtmlMonthPicker(data, options) {
        this.renderHtmlMonthPickerNative(data, options);
        this.renderHtmlMonthPickerCustom(data, options);
    }

    renderHtmlMonthPickerNative(data, options) {
        let div = document.createElement('div');
        div.setAttribute('class', `relative row-filter ${options.css}`);
        div.innerHTML = this.helpers.getHtmlStringMonthPickerNative(data, options);
        this.elements.form.appendChild(div);
    }

    renderHtmlMonthPickerCustom(data, options) {
        let dateRangeElement = document.getElementById(FORM_ROWS_ID.DATE_RANGE);

        let monthPickerTrigger = document.createElement('button');
        monthPickerTrigger.setAttribute('class', 'month-picker-trigger');

        let monthPickerSelect = document.createElement('div');
        monthPickerSelect.setAttribute('class', 'month-picker-select');

        let monthPickerClose = document.createElement('div');
        monthPickerClose.setAttribute('class', 'month-picker-close');
        monthPickerSelect.appendChild(monthPickerClose);

        data.forEach((element, index) => {

            // set initial values

            if (element.selected) {
                monthPickerTrigger.innerHTML = element.label;

                let inputStartDate = document.querySelector(`#${options.id} input[name="${options.nameStartDate}"]`);
                let inputEndDate = document.querySelector(`#${options.id} input[name="${options.nameEndDate}"]`);
                inputStartDate.value = element.startDate;
                inputEndDate.value = element.endDate;
            }

            let monthPickerOption = document.createElement('div');
            monthPickerOption.setAttribute('class', 'month-picker-option');
            monthPickerOption.setAttribute('data-start-date', element.startDate);
            monthPickerOption.setAttribute('data-end-date', element.endDate);

            monthPickerOption.innerHTML = element.label;
            monthPickerSelect.appendChild(monthPickerOption);

            // event listeners

            monthPickerOption.addEventListener('click', (e) => {
                e.preventDefault();

                if (monthPickerTrigger.innerHTML != monthPickerOption.innerHTML) {
                    // set date to inputs

                    let inputStartDate = document.querySelector(`#${options.id} input[name="${options.nameStartDate}"]`);
                    let inputEndDate = document.querySelector(`#${options.id} input[name="${options.nameEndDate}"]`);

                    let startDate = monthPickerOption.getAttribute('data-start-date');
                    let endDate = monthPickerOption.getAttribute('data-end-date');

                    inputStartDate.value = startDate;
                    inputEndDate.value = endDate;


                    // close month picker

                    monthPickerTrigger.innerHTML = monthPickerOption.innerHTML;

                    // fire event form change
                    const event = new Event('change');
                    this.elements.form.dispatchEvent(event);
                }

                monthPickerSelect.classList.remove('active');

            });
        });

        dateRangeElement.appendChild(monthPickerSelect);
        dateRangeElement.appendChild(monthPickerTrigger);


        // event listeners

        monthPickerTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            monthPickerSelect.classList.toggle('active');
        });


        monthPickerClose.addEventListener('click', (e) => {
            e.preventDefault();
            monthPickerSelect.classList.remove('active');
        });

        /* If the user clicks anywhere outside the month picker,
        then close month picker: */
        document.addEventListener("click", (e) => {
            if (!e.target.classList.contains("month-picker-trigger")) {
                monthPickerSelect.classList.remove('active');
            }
        });
    }

    closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    saveSelectedProperties(nextMapType) {
        if (this.properties.type == undefined) {
            return;
        }

        this.properties.previousProperties[this.properties.type] = this.properties.queryParams;
        // copy properties from choropleth to trends
        if (this.properties.type == MAP_TYPES.CHOROPLETH) {
            this.properties.previousProperties[MAP_TYPES.TRENDS] = this.properties.previousProperties[MAP_TYPES.CHOROPLETH];

            if (nextMapType != undefined && nextMapType == MAP_TYPES.HEAT) {
                this.copyPreviousPropertiesToHeatmap();
            }
        }

        // copy properties from trends to choropleth
        else if (this.properties.type == MAP_TYPES.TRENDS) {
            this.properties.previousProperties[MAP_TYPES.CHOROPLETH] = this.properties.previousProperties[MAP_TYPES.TRENDS];

            if (nextMapType != undefined && nextMapType == MAP_TYPES.HEAT) {
                this.copyPreviousPropertiesToHeatmap();
            }
        }

        // copy properties from heat to trends and choropleth
        else if (this.properties.type == MAP_TYPES.HEAT && nextMapType != undefined && !this.properties.choroplethFirstLoad) {
            this.copyPreviousPropertiesToChoropleth();
        }
    }

    loadPreviousProperties() {
        let previousProperties = this.properties.previousProperties[this.properties.type];
        if (!previousProperties || previousProperties == undefined) {

            // click on isp defined in url
            if (this.properties.ispFromUrl != undefined) {
                this.selectISP(this.properties.ispFromUrl);
            }

            // click on technology type:all and isp:all
            else if (
                (this.properties.type === MAP_TYPES.CHOROPLETH && this.properties.previousProperties[MAP_TYPES.CHOROPLETH] == undefined)
                || (this.properties.type === MAP_TYPES.TRENDS && this.properties.previousProperties[MAP_TYPES.TRENDS] == undefined)
                || (this.properties.type === MAP_TYPES.SOCIAL_MEDIA && this.properties.previousProperties[MAP_TYPES.SOCIAL_MEDIA] == undefined)
            ) {
                let choroplethElementsOnly = this.getChoroplethElementsOnly();
                if (choroplethElementsOnly != undefined && choroplethElementsOnly.length) {
                    for (let index = 0; index < choroplethElementsOnly.length; index++) {
                        const element = choroplethElementsOnly[index];
                        element.click();
                    }
                }
                const ispAllElement = this.getIspAll();
                if (ispAllElement) {
                    ispAllElement.click();
                }

            } else if (this.properties.type === MAP_TYPES.HEAT && this.properties.previousProperties[MAP_TYPES.HEAT] == undefined) {
                const ispAllElement = this.getIspAll();
                if (ispAllElement) {
                    ispAllElement.click();
                }
            }

            // click on access type: cellular for network coverage map
            if (this.properties.type === MAP_TYPES.HEAT && this.properties.previousProperties[MAP_TYPES.HEAT] == undefined) {
                // hardcoded data-nls="inputs.accessType.cellular" - cellular button
                const elementToClick = document.querySelector(`.checkmark[data-nls="inputs.accessType.cellular"]`);
                if (elementToClick) {
                    elementToClick.click();
                }
            }


            return;
        }


        // select Access Type
        if (previousProperties[FORM_ELEMENTS_NAMES.ACCESS_TYPE]) {

            let elementsToClick = document.querySelectorAll(`#${FORM_ROWS_ID.ACCESS_TYPE} label input[type="radio"]`);
            if (elementsToClick != undefined) {
                for (let index = 0; index < elementsToClick.length; index++) {
                    const element = elementsToClick[index];

                    if (element.getAttribute('value') == previousProperties[FORM_ELEMENTS_NAMES.ACCESS_TYPE]) {
                        element.click();
                    }
                }
            }
        }

        // select Technology
        if (previousProperties[FORM_ELEMENTS_NAMES.TECHNOLOGY_TYPE]) {

            let elementsToClick = document.querySelectorAll(`#${FORM_ROWS_ID.TECHNOLOGY_TYPE} label input[type="radio"]`);
            if (elementsToClick != undefined) {
                for (let index = 0; index < elementsToClick.length; index++) {
                    const element = elementsToClick[index];

                    if (element.getAttribute('value') == previousProperties[FORM_ELEMENTS_NAMES.TECHNOLOGY_TYPE]) {
                        element.click();
                        break;
                    }
                }
            }
        }

        // select ISP
        if (previousProperties[FORM_ELEMENTS_NAMES.ISP]) {

            // get name of ISP by value
            let options = document.querySelectorAll(`[name="${FORM_ELEMENTS_NAMES.ISP}"] option`);
            let ispName = null;

            if (options != undefined) {
                for (let index = 0; index < options.length; index++) {
                    const element = options[index];
                    if (element.getAttribute('value') == previousProperties[FORM_ELEMENTS_NAMES.ISP]) {
                        ispName = element.innerHTML.trim();
                        break;
                    }
                }
            }

            this.selectISP(ispName);
        }
    }

    copyPreviousPropertiesToHeatmap() {
        // if isp != 99999 ('all'), then copy property. If == 99999, don't copy property
        const ispValue = this.properties.previousProperties[MAP_TYPES.CHOROPLETH][FORM_ELEMENTS_NAMES.ISP];
        if (ispValue != 99999 && this.properties.previousProperties[MAP_TYPES.HEAT]) {
            this.properties.previousProperties[MAP_TYPES.HEAT][FORM_ELEMENTS_NAMES.ISP] = ispValue;
        }
    }

    copyPreviousPropertiesToChoropleth() {
        const ispValue = this.properties.previousProperties[MAP_TYPES.HEAT][FORM_ELEMENTS_NAMES.ISP];
        this.properties.previousProperties[MAP_TYPES.CHOROPLETH][FORM_ELEMENTS_NAMES.ISP] = ispValue;
        this.properties.previousProperties[MAP_TYPES.TRENDS][FORM_ELEMENTS_NAMES.ISP] = ispValue;
    }

    selectISP(ispName) {
        // find isp by name
        if (ispName != undefined) {

            let elementsToClick = document.querySelectorAll(`.row-filter-isp .custom-select .select-items div`);

            if (elementsToClick != undefined) {
                for (let index = 0; index < elementsToClick.length; index++) {
                    const element = elementsToClick[index];
                    if (element.innerHTML.toLowerCase().trim() == ispName.toLowerCase()) {
                        element.click();
                    }
                }
            }

        }
    }
}

